import React, { useState, useEffect } from 'react';
import Button from 'components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';

const LockerOpened = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [timer, setTimer] = useState(5);

  useEffect(() => {
    if (timer <= 0) {
      navigate('/home');
      return;
    }

    const countdown = setTimeout(() => {
      setTimer(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(countdown); // Clean up
  }, [timer, navigate]);

  return (
    <div className="h-full w-full flex flex-col gap-10 justify-center items-center px-8 py-5">
      <div className="h-full w-full flex flex-col justify-between py-5">
        <div className="flex flex-col gap-1">
          <span className="text-2xl font-semibold">
            {t('locker.door_opened')}
          </span>
          <span className="text-lg">
            {t('locker.take_asset')}
          </span>
        </div>
        <div className="flex justify-center">
          <div className="w-40 h-40 flex justify-center items-center bg-dark rounded-full">
            <Icon icon="lucide:check" width="70" className="text-white" />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-2xl font-semibold">
            {t('locker.please_close')}
          </span>
          <span className="text-lg">
            {t('general.thank_you')}
          </span>
        </div>
      </div>
      <Button
        onClick={() => navigate('/home')}
        color="primary"
        size="lg"
        text={`${t('general.back_to_home')} (${timer}s)`}
      />
    </div>
  );
};

export default LockerOpened;